import styled from '@emotion/styled';
import { Box } from '@updater/ui-uds';

export const LeftAligned = styled(Box)`
  ${({ theme }) => theme.mediaQueries.l} {
    // This ensures that the max width would match header spacing and alignment
    max-width: ${({ theme }) =>
      `calc(${theme.breakpoints[3]} + ${theme.space.xxl}px)`};
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    margin: 0 auto;
  }
`;
